import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { Cookies } from "../../../utils/cookies";



export const JoyTour=()=>{

  let SupervisorTourSteps = [] as any
  let AdminTourSteps = [] as any
  let AgentTourSteps = [] as any
  
  let productId = GetItemFromStorage(LocalStorage.PRODUCT_ID) ?? 0
  let planId = GetItemFromStorage(LocalStorage.PLAN_ID) ?? 0
  
  
  if(productId == 1){ // CCAAS
     AdminTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/14
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/14
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/14
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/14
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Analytics enable you to make data-driven decisions for improving customer experience and optimising business outcomes.
            </div>
            <div className="count">
              5/14
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Knowledge Base</h5>
            </div>
            <div className="tourBody">
                Centralised repository of information and resources for providing accurate and consistent customer support
            </div>
            <div className="count">
              6/14
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Workflow</h5>
            </div>
            <div className="tourBody">
              A user-friendly tool that enables building intelligent chatbots without coding. Harness the power of AI to create interactive conversational experiences effortlessly.
            </div>
            <div className="count">
              7/14
            </div>
          </>
        ),
      },
      {
        target: ".tour-recordings",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Recordings</h5>
            </div>
            <div className="tourBody">
            With the Recording Module, you can quickly save, organise, and access your records when needed
            </div>
            <div className="count">
              8/14
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Admin Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
            9/14
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              10/14
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step_call",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Call Icon</h5>
            </div>
            <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
            <div className="count">
              11/14
            </div>
          </>
        ),
      },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              12/14
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step-s",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              13/14
            </div>
          </>
        ),
      },
      {
        target: ".eleventh-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              14/14
            </div>
          </>
        ),
      },
    ] as any;
     SupervisorTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            {/* <div className="Tarrow"></div> */}
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/12
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/12
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/12
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
          <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/12
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Reports and analytics offer valuable insights for data-driven decision-making. By analyzing trends and customer behavior, businesses can optimize strategies, enhance customer experiences, and drive success. These tools empower informed decisions, leading to efficient operations, cost reduction, and continuous business growth.
            </div>
            <div className="count">
              5/12
            </div>
          </>
        ),
      },
      {
        target: ".tour-recordings",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Recordings</h5>
            </div>
            <div className="tourBody">
            With the Recording Module, you can quickly save, organise, and access your records when needed
            </div>
            <div className="count">
              6/12
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Supervisor Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              7/12
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'bottom',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
            8/12
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step_call",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Call Icon</h5>
            </div>
            <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
            <div className="count">
            9/12
            </div>
          </>
        ),
      },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
            10/12
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step-s",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              11/12
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              12/12
            </div>
          </>
        ),
      },
    ] as any;
     AgentTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/10
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/10
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>My Activity</h5>
            </div>
            <div className="tourBody">
              Manage your activity with this feature, you can view all your interactions with customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/10
            </div>
          </>
        ),
      },
    
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/10
            </div>
          </>
        ),
      },{
        target: ".tour-recordings",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Recordings</h5>
            </div>
            <div className="tourBody">
            With the Recording Module, you can quickly save, organise, and access your records when needed
            </div>
            <div className="count">
              5/10
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
             6/10
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Call Icon</h5>
            </div>
            <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
            <div className="count">
              7/10
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
               Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              8/10
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              9/10
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              10/10
            </div>
          </>
        ),
      },
    ] as any;
  
  }else if(productId == 15 && planId == 54){ // Chatbot Xaia 1
     AdminTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/10
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/10
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/10
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/10
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Analytics enable you to make data-driven decisions for improving customer experience and optimising business outcomes.
            </div>
            <div className="count">
              5/10
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Knowledge Base</h5>
            </div>
            <div className="tourBody">
                Centralised repository of information and resources for providing accurate and consistent customer support
            </div>
            <div className="count">
              6/10
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   placement: 'right',
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="tourHeader">
      //         <h5>Workflow</h5>
      //       </div>
      //       <div className="tourBody">
      //         A user-friendly tool that enables building intelligent chatbots without coding. Harness the power of AI to create interactive conversational experiences effortlessly.
      //       </div>
      //       <div className="count">
      //         6/{10}
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Admin Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              7/10
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              8/10
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         10/{10}
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   target: ".eighth-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Tracker</h5>
      //       </div>
      //       <div className="tourBody">
      //         Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
      //       </div>
      //       <div className="count">
      //         8/{10}
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".tenth-step-s",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
             9/10
            </div>
          </>
        ),
      },
      {
        target: ".eleventh-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              10/10
            </div>
          </>
        ),
      },
    ] as any;
     SupervisorTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            {/* <div className="Tarrow"></div> */}
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/9
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/9
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/9
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
          <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/9
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Reports and analytics offer valuable insights for data-driven decision-making. By analyzing trends and customer behavior, businesses can optimize strategies, enhance customer experiences, and drive success. These tools empower informed decisions, leading to efficient operations, cost reduction, and continuous business growth.
            </div>
            <div className="count">
              5/9
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Supervisor Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              6/9
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'bottom',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
            7/9
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //       7/9
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   target: ".eighth-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Tracker</h5>
      //       </div>
      //       <div className="tourBody">
      //         Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
      //       </div>
      //       <div className="count">
      //       7/9
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".ninth-step-s",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              8/9
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              9/9
            </div>
          </>
        ),
      },
    ] as any;
     AgentTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/7
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/7
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>My Activity</h5>
            </div>
            <div className="tourBody">
              Manage your activity with this feature, you can view all your interactions with customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/7
            </div>
          </>
        ),
      },
    
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/7
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              5/7
            </div>
          </>
        ),
      },
      // {
      //   target: ".fifth-step3",
      //   disableBeacon: true,
      //   content: (
      //     <><div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         6/9
      //       </div>
      //     </>
      //   ),
      // },
      // {
      //   target: ".sixth-step3",
      //   disableBeacon: true,
      //   content: (
      //     <><div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Tracker</h5>
      //       </div>
      //       <div className="tourBody">
      //          Allows you to monitor Queue and manage task allocation in real-time.
      //       </div>
      //       <div className="count">
      //         5/7
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".seventh-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              6/7
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
               7/7
            </div>
          </>
        ),
      },
    ] as any;
  
  }else if(productId == 15 && (planId == 55 || planId == 56)){ //Chatbot Xaia 3
     AdminTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/12
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/12
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/12
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/12
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Analytics enable you to make data-driven decisions for improving customer experience and optimising business outcomes.
            </div>
            <div className="count">
              5/12
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Knowledge Base</h5>
            </div>
            <div className="tourBody">
                Centralised repository of information and resources for providing accurate and consistent customer support
            </div>
            <div className="count">
              6/12
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Workflow</h5>
            </div>
            <div className="tourBody">
              A user-friendly tool that enables building intelligent chatbots without coding. Harness the power of AI to create interactive conversational experiences effortlessly.
            </div>
            <div className="count">
              7/12
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Admin Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              8/12
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              9/12
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         10/12
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              10/12
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step-s",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              11/12
            </div>
          </>
        ),
      },
      {
        target: ".eleventh-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              12/12
            </div>
          </>
        ),
      },
    ] as any;
     SupervisorTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            {/* <div className="Tarrow"></div> */}
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/10
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/10
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/10
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
          <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/10
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Reports and analytics offer valuable insights for data-driven decision-making. By analyzing trends and customer behavior, businesses can optimize strategies, enhance customer experiences, and drive success. These tools empower informed decisions, leading to efficient operations, cost reduction, and continuous business growth.
            </div>
            <div className="count">
              5/10
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Supervisor Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              6/10
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'bottom',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
            7/10
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //       7/10
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
            8/10
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step-s",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              9/10
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              10/10
            </div>
          </>
        ),
      },
    ] as any;
     AgentTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/8
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/8
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>My Activity</h5>
            </div>
            <div className="tourBody">
              Manage your activity with this feature, you can view all your interactions with customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/8
            </div>
          </>
        ),
      },
    
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/8
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              5/8
            </div>
          </>
        ),
      },
      // {
      //   target: ".fifth-step3",
      //   disableBeacon: true,
      //   content: (
      //     <><div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         7/9
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".sixth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
               Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              6/8
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              7/8
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              8/8
            </div>
          </>
        ),
      },
    ] as any;
  
  }else if(productId == 15){ //Chatbot common
     SupervisorTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            {/* <div className="Tarrow"></div> */}
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/10
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/10
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/10
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
          <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/10
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Reports and analytics offer valuable insights for data-driven decision-making. By analyzing trends and customer behavior, businesses can optimize strategies, enhance customer experiences, and drive success. These tools empower informed decisions, leading to efficient operations, cost reduction, and continuous business growth.
            </div>
            <div className="count">
              5/10
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Supervisor Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
              6/10
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'bottom',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
            7/10
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //       7/10
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
            8/10
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step-s",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              9/10
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              10/10
            </div>
          </>
        ),
      },
    ] as any;
     AgentTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/8
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/8
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>My Activity</h5>
            </div>
            <div className="tourBody">
              Manage your activity with this feature, you can view all your interactions with customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
              3/8
            </div>
          </>
        ),
      },
    
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/8
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              5/8
            </div>
          </>
        ),
      },
      // {
      //   target: ".fifth-step3",
      //   disableBeacon: true,
      //   content: (
      //     <><div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         7/9
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".sixth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
               Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              6/8
            </div>
          </>
        ),
      },
      {
        target: ".seventh-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              7/8
            </div>
          </>
        ),
      },
      {
        target: ".eigth-step3",
        disableBeacon: true,
        content: (
          <><div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              8/8
            </div>
          </>
        ),
      },
    ] as any;
     AdminTourSteps = [
      {
        target: ".first-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Dashboard</h5>
            </div>
            <div className="tourBody">
              Our Dashboard gives you an overview of key metrics,
              Live contact centre performance, Historical datas, Agent activity and It’s customisable to your needs.
            </div>
            <div className="count">
              1/11
            </div>
          </>
        ),
      },
      {
        target: ".second-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Contacts</h5>
            </div>
            <div className="tourBody">
              Contacts allow you to manage customer information. With our powerful search and filtering options, you can quickly find and organise all your customer information in one place.
            </div>
            <div className="count">
              2/11
            </div>
          </>
        ),
      },
      {
        target: ".third-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>All Activity</h5>
            </div>
            <div className="tourBody">
              Manage your Agent activity with this feature, you can view all the interactions between your agents and customers.This allows you to identify areas where you can improve.
            </div>
            <div className="count">
               3/11
            </div>
          </>
        ),
      },
      {
        target: ".fourth-step",
        placement:'right',
        disableBeacon: true,
        content: (
          <>
    
            <div className="tourHeader">
              <h5>Internal Chat</h5>
            </div>
            <div className="tourBody">
            Internal Chat is a feature used for session-based interactions where users can ask the Supervisor and other agents for advice or assistance while on a call or in a chat.
            </div>
            <div className="count">
              4/11
            </div>
          </>
        ),
      },
      {
        target: ".fifth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Reports & Analytics</h5>
            </div>
            <div className="tourBody">
              Analytics enable you to make data-driven decisions for improving customer experience and optimising business outcomes.
            </div>
            <div className="count">
              5/11
            </div>
          </>
        ),
      },
      {
        target: ".sixth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Knowledge Base</h5>
            </div>
            <div className="tourBody">
                Centralised repository of information and resources for providing accurate and consistent customer support
            </div>
            <div className="count">
              6/11
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   placement: 'right',
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="tourHeader">
      //         <h5>Workflow</h5>
      //       </div>
      //       <div className="tourBody">
      //         A user-friendly tool that enables building intelligent chatbots without coding. Harness the power of AI to create interactive conversational experiences effortlessly.
      //       </div>
      //       <div className="count">
      //         6/11
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eigth-step",
        placement: 'right',
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Admin Settings</h5>
            </div>
            <div className="tourBody">
              Explore the Settings and gain full control over your contact centre operations.
            </div>
            <div className="count">
             7/11
            </div>
          </>
        ),
      },
      {
        target: ".ninth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Status</h5>
            </div>
            <div className="tourBody">Manage your availability to take on new tasks or engage with customers.</div>
            <div className="count">
              8/11
            </div>
          </>
        ),
      },
      // {
      //   target: ".seventh-step",
      //   disableBeacon: true,
      //   content: (
      //     <>
      //       <div className="Tarrow"></div>
      //       <div className="tourHeader">
      //         <h5>Call Icon</h5>
      //       </div>
      //       <div className="tourBody">Connect with customer quickly and efficiently. With just one click, you can start a voice call, making it easy to provide support.</div>
      //       <div className="count">
      //         10/11
      //       </div>
      //     </>
      //   ),
      // },
      {
        target: ".eighth-step",
        disableBeacon: true,
        content: (
          <>
            <div className="Tarrow"></div>
            <div className="tourHeader">
              <h5>Tracker</h5>
            </div>
            <div className="tourBody">
              Tracker gives you real-time visibility into your team's Activity, performance. Allows you to monitor Queue and manage task allocation in real-time.
            </div>
            <div className="count">
              9/11
            </div>
          </>
        ),
      },
      {
        target: ".tenth-step-s",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Notification</h5>
            </div>
            <div className="tourBody">Find important updates and customer inquiries in real-time under the Notification.</div>
            <div className="count">
              10/11
            </div>
          </>
        ),
      },
      {
        target: ".eleventh-step",
        disableBeacon: true,
        content: (
          <>
            <div className="tourHeader">
              <h5>Profile</h5>
            </div>
            <div className="tourBody">Manage your personal and account Information and Customise your interface.</div>
            <div className="count">
              11/11
            </div>
          </>
        ),
      },
    ] as any;
  }

  return {
    SupervisorTourSteps,
    AdminTourSteps,
    AgentTourSteps
  }
}
